import Model, {
  AsyncBelongsTo,
  AsyncHasMany,
  attr,
  belongsTo,
  hasMany,
} from '@ember-data/model';

import type HotelModel from 'admin-panel/models/hotel';
import type RoomModel from 'admin-panel/models/room';
import type RoomControlConfigTvChannelModel from 'admin-panel/models/room-control/config-tv-channel';
import type RoomControlIrDeviceModel from 'admin-panel/models/room-control/ir-device';

export default class RoomControlConfigurationModel extends Model {
  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @hasMany('room')
  declare rooms: AsyncHasMany<RoomModel>;

  @hasMany('room-control/config-tv-channel')
  declare configTvChannels: AsyncHasMany<RoomControlConfigTvChannelModel>;

  @hasMany('room-control/ir-device')
  declare irDevices: AsyncHasMany<RoomControlIrDeviceModel>;

  @attr
  declare name: string;

  @attr
  declare configTvChannelIds: number[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/configuration': RoomControlConfigurationModel;
  }
}
